
<div>
	<v-dialog :key="dialogKey" v-model="showDialog" persistent scrollable :max-width="$vuetify.breakpoint.mobile ? '75%' : '50%'">
		<v-card class="justify-center text-center card-rounded pb-5" min-height="90vh">
			<v-card-title
				class="pa-2 white--text justify-center text-center secondary"
				style="font-family: Montserrat; font-style: normal; font-weight: bold; font-size: 12px; line-height: 7px; text-align: center"
			>
				<v-row>
					<v-spacer></v-spacer>
					<span class="headline white--text">Edit Offer</span>
					<v-spacer></v-spacer>
				</v-row>
				<v-btn icon color="white" @click="close">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-card-title>

			<v-card-text class="text-center justify-center">
				<v-container class="card-rounded pb-2 text-center justify-center">
					<v-form>
						<div>
							<v-row>
								<v-col class="justify-center text-center">
									<v-btn-toggle v-model="calendarInputMode" mandatory>
										<v-btn
											rounded
											small
											:color="calendarInputMode == 0 ? 'primary' : '#FFF'"
											:class="[calendarInputMode == 0 ? 'white--text' : 'primary--text text--darken-2']"
											style="
												border-radius: 20px 0px 0px 20px;
												font-family: Montserrat;
												font-style: normal;
												font-weight: bold;
												font-size: 14px;
												line-height: 17px;
												text-align: center;
											"
											@click="calculateRequestDates(0)"
										>
											Date range
										</v-btn>

										<v-btn
											rounded
											small
											:color="calendarInputMode == 1 ? 'primary' : '#FFF'"
											:class="[calendarInputMode == 1 ? 'white--text' : 'primary--text text--darken-2']"
											style="
												border-radius: 0px 20px 20px 0px;
												font-family: Montserrat;
												font-style: normal;
												font-weight: bold;
												font-size: 14px;
												line-height: 17px;
												text-align: center;
											"
											@click="calculateRequestDates(1)"
										>
											Specific days
										</v-btn>
									</v-btn-toggle>
								</v-col>
							</v-row>
							<v-date-picker
								v-model="selectedDates"
								:min="new Date().toISOString().substr(0, 10)"
								header-color="primary"
								color="primary"
								full-width
								no-title
								:multiple="calendarInputMode == 1"
								:range="calendarInputMode == 0"
								class="elevation-0"
							></v-date-picker>

							<v-row>
								<v-col>
									<v-dialog
										ref="startDatedialog"
										v-model="startDateModal"
										:value="computedStartDateFormatted"
										clearable
										:return-value.sync="startDate"
										persistent
										width="290px"
									>
										<template #activator="{ on }">
											<span class="font-weight-bold">Start Date:</span>
											<v-text-field v-model="startDate" :rules="[rules.startDate]" filled dense readonly v-on="on"></v-text-field>
										</template>
										<v-date-picker v-model="startDate" :allowed-dates="allowedStartDates" header-color="primary" color="primary" :min="minDate" scrollable>
											<v-spacer></v-spacer>
											<v-btn text color="primary" @click="startDateModal = false">Cancel</v-btn>
											<v-btn
												text
												color="primary"
												@click="
													$refs.startDatedialog.save(startDate);
													if (calendarInputMode === 0) calculateRequestDates();
												"
												>OK</v-btn
											>
										</v-date-picker>
									</v-dialog>
								</v-col>

								<v-col>
									<v-dialog ref="endDateDialog" v-model="endDateModal" :return-value.sync="endDate" persistent width="290px">
										<template #activator="{ on }">
											<span class="font-weight-bold">End Date:</span>
											<v-text-field
												v-model="endDate"
												:value="computedEndDateFormatted"
												clearable
												:rules="[rules.endDate]"
												filled
												dense
												readonly
												v-on="on"
											></v-text-field>
										</template>
										<v-date-picker v-model="endDate" header-color="primary" color="primary" :min="minDate" scrollable>
											<v-spacer></v-spacer>
											<v-btn text color="primary" @click="endDateModal = false">Cancel</v-btn>
											<v-btn
												text
												color="primary"
												@click="
													$refs.endDateDialog.save(endDate);
													if (calendarInputMode === 0) calculateRequestDates();
												"
												>OK</v-btn
											>
										</v-date-picker>
									</v-dialog>
								</v-col>
							</v-row>

							<p class="font-weight-bold black--text mb-0 mt-0">Time</p>
							<v-row>
								<v-col>
									<v-dialog ref="startTimeDialog" v-model="startTimeModal" :return-value.sync="startTime" persistent width="290px">
										<template #activator="{ on }">
											<span class="font-weight-bold">Start Time:</span>
											<v-text-field v-model="startTime" placeholder="Start Time:" readonly filled dense v-on="on"></v-text-field>
										</template>
										<v-time-picker v-if="startTimeModal" v-model="startTime" full-width format="24hr" :allowed-minutes="[0, 15, 30, 45]">
											<v-spacer></v-spacer>
											<v-btn text color="primary" @click="startTimeModal = false">Cancel</v-btn>
											<v-btn
												text
												color="primary"
												@click="
													$refs.startTimeDialog.save(startTime);
													updateRequestDateTimes(startTime, '');
												"
												>OK</v-btn
											>
										</v-time-picker>
									</v-dialog>
								</v-col>

								<v-col>
									<v-dialog ref="endTimedialog" v-model="endTimeModal" :return-value.sync="endTime" persistent width="290px">
										<template #activator="{ on }">
											<span class="font-weight-bold">End Time:</span>
											<v-text-field v-model="endTime" placeholder="End Time:" readonly filled dense v-on="on"></v-text-field>
										</template>
										<v-time-picker v-if="endTimeModal" v-model="endTime" full-width format="24hr" :allowed-minutes="[0, 15, 30, 45]">
											<v-spacer></v-spacer>
											<v-btn text color="primary" @click="endTimeModal = false">Cancel</v-btn>
											<v-btn
												text
												color="primary"
												@click="
													$refs.endTimedialog.save(endTime);
													updateRequestDateTimes('', endTime);
												"
												>OK</v-btn
											>
										</v-time-picker>
									</v-dialog>
								</v-col>
							</v-row>

							<p v-if="startDate !== null && endDate !== null && endDate !== ''" class="font-weight-bold black--text mb-0 mt-0">Change times per day</p>
							<v-row v-if="startDate !== null && endDate !== null && endDate !== ''" class="text-center justify-center">
								<v-col>
									<div style="display: flex; overflow: auto">
										<v-card
											v-for="date in request_dates"
											:key="date.date"
											outlined
											elevation="1"
											class="ml-1 mr-1 mt-2 mb-2 pl-1 pr-1"
											style="border-radius: 8px; !important"
											@click="onClickDateIcon(date)"
										>
											<v-row no-gutters>
												<v-col cols="12">
													<calendar-date-icon
														:color="'primary'"
														:date="date.date"
														:start_time="getLocumDayTime(date.date, 'start_time')"
														:end_time="getLocumDayTime(date.date, 'end_time')"
														small
														class="ml-1 mr-1 mt-2 mb-0 justify-center text-center"
														@click="onClickDateIcon(date)"
													>
													</calendar-date-icon>
												</v-col>
											</v-row>
										</v-card>
									</div>
								</v-col>
								<v-col>
									<v-dialog v-model="showEditRequestTimeDialog" persistent scrollable width="290px" :max-width="$vuetify.breakpoint.mobile ? '80%' : '25%'">
										<v-card class="justify-center text-center card-rounded pb-5" min-height="40vh">
											<v-card-title
												class="pa-2 white--text justify-center text-center primary"
												style="font-family: Montserrat; font-style: normal; font-weight: bold; font-size: 12px; line-height: 7px; text-align: center"
											>
												<v-row>
													<v-spacer></v-spacer>
													<span class="headline white--text">{{ EditRequestTimeDialogTitle }}</span>
													<v-spacer></v-spacer>
												</v-row>
												<v-btn icon color="white" @click="closeRequestTimeDialog()">
													<v-icon>mdi-close</v-icon>
												</v-btn>
											</v-card-title>

											<v-card-text class="text-center justify-center">
												<v-container class="card-rounded pb-2 text-center justify-center">
													<v-form>
														<div>
															<v-row>
																<v-col>
																	<v-dialog v-model="startTimeModal" :return-value.sync="startTime" persistent width="290px">
																		<template #activator="{ on }">
																			<span class="font-weight-bold">Start Time:</span>
																			<v-text-field
																				v-model="startTimeEdit"
																				placeholder="Start Time:"
																				readonly
																				filled
																				dense
																				v-on="on"
																			></v-text-field>
																		</template>
																		<v-time-picker
																			v-if="startTimeModal"
																			v-model="startTimeChange"
																			full-width
																			format="24hr"
																			:allowed-minutes="[0, 15, 30, 45]"
																		>
																			<v-spacer></v-spacer>
																			<v-btn text color="primary" @click="startTimeModal = false">Cancel</v-btn>
																			<v-btn text color="primary" @click="updateStartTimeEdit()">OK</v-btn>
																		</v-time-picker>
																	</v-dialog>
																</v-col>
															</v-row>
															<v-row>
																<v-col>
																	<v-dialog v-model="endTimeModal" :return-value.sync="endTime" persistent width="290px">
																		<template #activator="{ on }">
																			<span class="font-weight-bold">End Time:</span>
																			<v-text-field
																				v-model="endTimeEdit"
																				placeholder="End Time:"
																				readonly
																				filled
																				dense
																				v-on="on"
																			></v-text-field>
																		</template>
																		<v-time-picker
																			v-if="endTimeModal"
																			v-model="endTimeChange"
																			full-width
																			format="24hr"
																			:allowed-minutes="[0, 15, 30, 45]"
																		>
																			<v-spacer></v-spacer>
																			<v-btn text color="primary" @click="endTimeModal = false">Cancel</v-btn>
																			<v-btn text color="primary" @click="updateEndTimeEdit()">OK</v-btn>
																		</v-time-picker>
																	</v-dialog>
																</v-col>
															</v-row>
														</div>
													</v-form>
												</v-container>
											</v-card-text>
											<v-card-actions>
												<v-row class="pb-1">
													<v-spacer />
													<v-col>
														<v-btn block :class="[contrastOnPrimary, 'mt-1']" :height="30" color="primary" @click="saveTimesForDate()"
															><span style="font-size: 10px">Save</span></v-btn
														>
													</v-col>
												</v-row>
											</v-card-actions>
										</v-card>
									</v-dialog>
								</v-col>
							</v-row>

							<p class="font-weight-bold black--text mb-0 mt-0">Budget</p>
							<v-row>
								<v-col>
									<span class="font-weight-bold">From:</span>
									<v-text-field
										v-model="budgetFrom"
										:rules="[rules.budgetFrom]"
										prefix="R"
										filled
										dense
										min="0"
										step="50"
										suffix="p/h"
										type="number"
									></v-text-field>
								</v-col>
								<v-col>
									<span class="font-weight-bold">To:</span>
									<v-text-field
										v-model="budgetTo"
										:rules="[rules.budgetTo]"
										prefix="R"
										suffix="p/h"
										type="number"
										:min="budgetFrom"
										step="50"
										filled
										dense
										hide-details
										single-line
									></v-text-field>
								</v-col>
							</v-row>

							<div v-if="showLunchOptions">
								<p class="font-weight-bold black--text mb-0 mt-0">Lunch</p>
								<v-row mt-0>
									<v-col class="text-center justify-center">
										<v-spacer />
										<v-btn-toggle v-model="lunchValue" block dense rounded color="secondary" class="white--text" mandatory>
											<v-btn value="paid"> Paid </v-btn>
											<v-btn style="display: none" value="default"></v-btn>
											<v-btn value="unpaid" :disabled="lunchDuration === '0.5'"> Unpaid </v-btn>
										</v-btn-toggle>
										<v-spacer />
									</v-col>
								</v-row>

								<v-row v-if="lunchValue !== 'default'" no-gutters class="mt-3 mb-2">
									<v-col class="text-center justify-center">
										<v-spacer />
										<v-btn-toggle v-model="lunchDuration" mandatory depressed block rounded dense color="secondary" :class="contrastOnSecondary">
											<v-btn value="0.5" :disabled="lunchValue === 'unpaid'"> 30 min </v-btn>

											<v-btn value="1"> 1 hour </v-btn>
										</v-btn-toggle>
										<v-spacer />
									</v-col>
								</v-row>
							</div>

							<v-row no-gutters>
								<v-col>
									<v-textarea v-model="notes" label="Notes" background-color="#F4F4F4" rounded outlined no-resize></v-textarea>
								</v-col>
							</v-row>
						</div>
					</v-form>
				</v-container>
			</v-card-text>
			<v-card-actions>
				<v-row class="pb-1">
					<v-spacer />
					<v-col :cols="3" align="center" justify="center">
						<v-btn block :class="[contrastOnPrimary, 'mt-1']" :height="30" color="primary" @click="saveOffer()"
							><span style="font-size: 10px">Save Offer</span></v-btn
						>
					</v-col>
				</v-row>
			</v-card-actions>
		</v-card>
	</v-dialog>
	<v-dialog v-model="showWarning" persistent :max-width="$vuetify.breakpoint.mobile ? '75%' : '50%'">
		<v-card class="justify-center text-center card-rounded pb-5" min-height="20vh" style="overflow-x: hidden">
			<v-card-title
				class="pa-2 white--text justify-center text-center secondary"
				style="font-family: Montserrat; font-style: normal; font-weight: bold; font-size: 12px; line-height: 7px; text-align: center"
			>
				<v-row>
					<v-spacer></v-spacer>
					<span class="headline white--text">Please Note</span>
					<v-spacer></v-spacer>
				</v-row>
			</v-card-title>

			<v-card-text>
				<v-container>
					<v-form>
						<v-row>
							<v-col class="justify-center text-center">
								Proffesionals have already applied to this Public Offer. If you edit this offer, all the applications linked to this offer will be removed. The
								professionals that has already applied to this offer will be notified that they need to reapply to this updated offer.
							</v-col>
						</v-row>
					</v-form>
				</v-container>
			</v-card-text>
			<v-card-actions>
				<v-row class="pb-1">
					<v-spacer />
					<v-col :cols="3" align="center" justify="center">
						<v-btn block :class="[contrastOnPrimary, 'mt-1']" :height="30" color="primary" @click="showWarning = false"
							><span style="font-size: 10px">Discard Edit</span></v-btn
						>
					</v-col>
					<v-col :cols="3" align="center" justify="center">
						<v-btn
							block
							class="white--text mt-1"
							:height="30"
							color="secondary"
							@click="
								showWarning = false;
								openEditWindow();
							"
							><span style="font-size: 10px">Continue Edit</span></v-btn
						>
					</v-col>
				</v-row>
			</v-card-actions>
		</v-card>
	</v-dialog>
</div>
